import React, { useState } from "react";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";

import { env } from "config";
import { isRu } from "services/region/region";

import "./CookieNotice.less";

const STORAGE_KEY = "jmix-store-cookie-notice-accepted";

function getPrivacyPolicyUrl(): string {
  return env.REACT_APP_JMIX_PRIVACY_POLICY_URL
    || (isRu() ? "https://www.jmix.ru/privacy-policy/" : "https://www.jmix.io/privacy-policy/");
}

/**
 * Cookie usage notice required for the ru instance (RKN). Rendered until the visitor
 * dismisses it; the dismissal is remembered in localStorage.
 */
export const CookieNotice = () => {
  const [visible, setVisible] = useState<boolean>(() => {
    if (!isRu()) {
      return false;
    }
    try {
      return localStorage.getItem(STORAGE_KEY) === null;
    } catch (e) {
      return true;
    }
  });

  if (!visible) {
    return null;
  }

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (e) {
      // localStorage unavailable — the notice will re-appear next visit
    }
    setVisible(false);
  };

  return (
    <div className="cookie-notice" role="dialog" aria-live="polite">
      <span className="cookie-notice__text">
        <FormattedMessage
          id="jmix-store.cookie-notice.text"
          values={{
            link: (
              <a href={getPrivacyPolicyUrl()} target="_blank" rel="noreferrer">
                <FormattedMessage id="jmix-store.cookie-notice.link" />
              </a>
            ),
          }}
        />
      </span>
      <Button type="primary" size="small" onClick={accept}>
        <FormattedMessage id="jmix-store.cookie-notice.accept" />
      </Button>
    </div>
  );
};
